import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                                from '../sign-in/xv-hotel';
import { MLText, mlBroker }                       from '../../services/MLText';
import { dmLoading }                              from '../loading/loading';
//import { DomSanitizer, SafeUrl }                  from '@angular/platform-browser';

export class dmDoc {
    NewLoading: (pMessage: string) => dmLoading;
    app: mlBroker;

    GetInAction: () => boolean;
    SetInAction: (pInAction: boolean) => void;

    HotelID: number;
    //RoomTypeID: number;
    HotelDocID: number;
    Filename: string;
    Verified: boolean;
    SortOrder: number;

    Path: string;
    //Path: SafeUrl;

    LangID: number;
    Description: string;
    DocTypeID; number;

    DescriptionByLangID: string[];
    MarkURISafe: (pURI: string) => any;

    constructor(
        pNewLoading: (pMessage: string) => dmLoading
        , pApp: mlBroker
        , pGetInAction: () => boolean
      , pSetInAction: (pInAction: boolean) => void
      , pDocEntry: RQService.Ota.GetHotelDocsRow      
    ) {
        this.NewLoading = pNewLoading;
        this.app = pApp;
        this.GetInAction = pGetInAction;
        this.SetInAction = pSetInAction;

        this.Filename = pDocEntry.Filename;

        this.Path = encodeURI(
          'https://www.tobook.com/docs/' + this.Filename
        );
        
        this.HotelID = pDocEntry.HotelID;
        this.HotelDocID = pDocEntry.DocID;
        this.SortOrder = pDocEntry.DocSortOrder;
        this.DocTypeID = pDocEntry.DocTypeID;
        this.LangID = pDocEntry.LangID;
        console.log("LID:" + this.LangID);
        this.Description = pDocEntry.Description;
        console.log("D:" + this.Description);
        this.DescriptionByLangID = [];
    }
  

    public AddDescription(
      pDocEntry: RQService.Ota.GetHotelDocsRow
      ): void {
      this.DescriptionByLangID[pDocEntry.LangID] = pDocEntry.Description;
      console.log("pDocEntry.LangID]:" + pDocEntry.LangID);
      console.log("pDocEntry.Description:" + pDocEntry.Description);
      console.log("pDocEntry.DOCID:" + pDocEntry.DocID);


    }

    public ChangeDescriptionLangID(pLangID: number) {
      this.LangID = pLangID;
      console.log("L:" + pLangID);
      console.log("this.LangID:" + this.LangID);

      console.log("D2:" + this.Description);

      this.Description = this.DescriptionByLangID[
          this.LangID
      ];

      console.log("D3:" + this.Description);
      console.log("LangID-D3:" + this.LangID);

    }

  public SaveDescription(): void {
    if (this.GetInAction()) { return; }

    this.SetInAction(true);

    let loading = this.NewLoading(
      this.app.Text('SavingMark', 'Saving...')
    );

    loading.Show(() => {
      let saveParams = RQParam.OtaEditHotelDocDescriptionParams();

      saveParams.HotelID = this.HotelID;
      saveParams.DocID = this.HotelDocID;
      saveParams.LangID =this.LangID; //have to check whether it is overriding onChange
      saveParams.DocTypeID = this.DocTypeID;
      saveParams.Description = this.Description.trim();
      console.log("SaveDescription: D: " + this.Description);
      RQService.Ota.EditHotelDocDescription(saveParams).then((result) => {
        this.Description = this.Description.trim();

        loading.Dismiss();

        this.SetInAction(false);
      });
    });
  }
}

export class DocsViewModel {
    ShowAlert: (pTitle: string, pMessage: string) => void;
    BackToSignIn: () => void;
    NewLoading: (pMessage: string) => dmLoading;
    ShowConfirmation: (pTitle: string, pMessage: string, pAction: () => void) => void;
    ScrollToBottom: () => void;

    GetInAction: () => boolean;
    SetInAction: (pInAction: boolean) => void;

    InAction: boolean;

    mlText: MLText;
    app: mlBroker;
    ml: mlBroker;
    Hotel: dmHotel;
    LangID: number;
    DocTypeID: number;
    //MarkURISafe: (pURI: string) => SafeUrl;

    NewDocFileName: string;
    NewDocDescriptionEN: string;

    FileSelected: boolean;

    //RoomTypesParams = RQParam.PmsGetRoomTypesParams();
    AllDocsParams = RQParam.OtaGetHotelDocsParams();

    Languages: RQService.Pms.GetLanguagesRow[];
    DocTypes: RQService.Ota.GetDocTypesRow[];
    DocTypesParams = RQParam.OtaGetDocTypesParams();

    //DocTypes: RQService.Ota.GetHotelDocsRow[];
    Docs: dmDoc[];

    constructor(
        pMLText: MLText
        , pHotel: dmHotel
        , pBackToSignIn: () => void
        , pShowAlert: (pTitle: string, pMessage: string) => void
        , pNewLoading: (pMessage: string) => dmLoading
        , pShowConfirmation: (pTitle: string, pMessage: string, pAction: () => void) => void
        , pScrollToBottom: () => void
        //, sanitizer: DomSanitizer
    ) {
        this.mlText = pMLText;
        this.LangID = this.mlText.GetLangID();
        this.app = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml = this.mlText.GetBroker(
            'HotelAreaBrochures'
        );

        this.Hotel = pHotel;
        this.BackToSignIn = pBackToSignIn;
        this.ShowAlert = pShowAlert;
        this.NewLoading = pNewLoading;
        this.ShowConfirmation = pShowConfirmation;
        this.ScrollToBottom = pScrollToBottom;

        this.InAction = false;

        this.GetInAction = () => {
            return this.InAction;
        };

        this.SetInAction = (pInAction: boolean) => {
            this.InAction = pInAction;
        };

        this.NewDocFileName = '';
        this.NewDocDescriptionEN = '';
        this.FileSelected = false;
        console.log("before sanitizer");

        //this.MarkURISafe = (pURI: string) => {
        //  return sanitizer.bypassSecurityTrustUrl(pURI);
        //};


        //this.MarkURISafe;
        //this.filepath = sanitizer.bypassSecurityTrustUrl("https://www.tobook.com/photos/docs/test.pdf");
        console.log("after sanitizer");
        this.AllDocsParams.HotelID = this.Hotel.HotelID;
        //this.RoomTypesParams.HotelID = this.Hotel.HotelID;
        //this.RoomTypesParams.LangID = this.LangID;

        this.Docs = [];
        this.Languages = [];
        this.DocTypes = [];

        this.setLanguagesHandler();
        this.setDocTypesHandler();

        this.SetInAction(true);
        this.populateDocTypes(() => {
        //  this.refreshDocs(() => {
          //  this.SetInAction(false);
        //  });
        });

        this.populateLanguages(() => {
          
          //this.populateRoomTypes(() => {
          this.refreshDocs(() => {
              this.SetInAction(false);
          });
        //});
        });
    }

    private setLanguagesHandler(): void {
        RQHandlers.Pms.GetLanguages = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let languages = response.RQueryResult;

            this.Languages.length = 0;

            for (let i = 0; i < languages.length; i++) {
                let language = RQService.Pms.PopulateGetLanguagesRow(
                    languages[i]
                );

                console.log('row push');

                this.Languages.push(language);
            }
        };
    }

  private setDocTypesHandler(): void {
    RQHandlers.Ota.GetDocTypes= (result) => {
      let response = result as any;
      console.log('doctypes.result' + response);
      if (response.HasErrorOrException) { return; }

      let doctypes = response.RQueryResult;

      this.DocTypes.length = 0;

      for (let i = 0; i < doctypes.length; i++) {
        let doctype = RQService.Ota.PopulateGetDocTypesRow(//  Pms.PopulateGetLanguagesRow(
            doctypes[i]
          );

        console.log('doctypes row push');

        this.DocTypes.push(doctype);
        }
      };
    }

    private populateLanguages(pAction: () => void): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

      loading.Show(() => {

        console.log("L in populateLanguages " + this.LangID);

            this.DocTypesParams.LangID = this.LangID;
            RQService.Ota.GetDocTypes(
              this.DocTypesParams
            ).then((result) => {
              //loading.Dismiss();

              //  //pAction();
            });

            RQService.Pms.GetLanguages(
                {}
            ).then((result) => {
                loading.Dismiss();

                pAction();
            });
        });
    }

    private populateDocTypes(pAction: () => void): void {
      //let loading = this.NewLoading(
      //  this.app.Text('LoadingMark', 'Loading...')
      //);
      this.DocTypesParams.LangID = this.LangID;
      //loading.Show(() => {
        RQService.Ota.GetDocTypes(
          this.DocTypesParams
        ).then((result) => {
          //loading.Dismiss();

          pAction();
        });
      //});


      //RQService.Ota.GetHotelDocs(
      //  this.AllDocsParams
      //).then((result) => {
      //  let response = result as any;
    }

    

    private refreshDocs(pAction: () => void): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
          let SelectedLangIDByHotelDocID: number[] = [];
          console.log("loaded docs-length:" + this.Docs.length + " hotelid;" + this.Hotel.HotelID);
          for (let i = 0; i < this.Docs.length; i++) {
            let doc: dmDoc = this.Docs[i];
            console.log("loaded docs");
            SelectedLangIDByHotelDocID[doc.HotelDocID] = doc.LangID;
            }

          RQService.Ota.GetHotelDocs(
            this.AllDocsParams
            ).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { return; }

                let docEntries = response.RQueryResult;

                this.Docs.length = 0;
                //this.MarkURISafe = (pURI: string) => {
                //  return sanitizer.bypassSecurityTrustUrl(pURI);
                //};
                let currentHotelDocID: number = 0;
                let currentDoc: dmDoc = null;
                let docURL: any;

                for (let i = 0; i < docEntries.length; i++) {
                  let docEntry = RQService.Ota.PopulateGetHotelDocsRow(
                    docEntries[i]
                  );

                  console.log('row push doc-entries');
                  console.log(docEntries[i]);

                  //this.MarkURISafe;
                  if (
                    (currentDoc == null)
                    || (currentHotelDocID != docEntry.DocID)
                  ) {
                      currentDoc = new dmDoc(
                          this.NewLoading
                          , this.app
                          , this.GetInAction
                          , this.SetInAction
                          , docEntry                      
                      );

                      this.Docs.push(currentDoc);

                      currentHotelDocID = currentDoc.HotelDocID;
                  }

                  currentDoc.AddDescription(docEntry)
                }
             
                for (let i = 0; i < this.Docs.length; i++) {
                  let doc: dmDoc = this.Docs[i];

                  //if (SelectedLangIDByHotelDocID[doc.HotelDocID]) {
                  //    doc.ChangeDescriptionLangID(
                  //        SelectedLangIDByHotelDocID[doc.HotelDocID]
                  //    );
                  //} else {
                  //    doc.ChangeDescriptionLangID(1);
                  //}
                }
                console.log("langid:" + SelectedLangIDByHotelDocID);
                loading.Dismiss();

                pAction();
            });
        });
    }

    public SetDocLangID(
      DocID: number
      ,DocTypeID: number
      , Description:  string
      , LangID:       number
    ): void {
      console.log('Set DID :' + DocID);
      console.log("Desc" + Description);
      console.log("LangID" + LangID);
      console.log("DocTypeID" + DocTypeID);


      let loading = this.NewLoading(
        this.app.Text('SavingMark', 'Saving...')
      );

      this.InAction = true;

      loading.Show(() => {
        //let addParams = RQParam.OtaD PmsMigrateRoomParams();
        let editDescriptionParams = RQParam.OtaEditHotelDocDescriptionParams();

        editDescriptionParams.HotelID = this.Hotel.HotelID;
        editDescriptionParams.DocID = DocID;
        editDescriptionParams.LangID = LangID;
        editDescriptionParams.DocTypeID = DocTypeID;// DocTypeID;
        editDescriptionParams.Description = Description;
        RQService.Ota.EditHotelDocDescription(editDescriptionParams).then((result) => {
          this.NewDocDescriptionEN = '';

          loading.Dismiss();

          this.refreshDocs(() => {
            this.SetInAction(false);
          });
        });
        //  addParams.HotelID = this.Hotel.HotelID;
        //  addParams.LangID = this.LangID;
        //  addParams.RoomID = RoomID;
        //  addParams.RoomTypeID = RoomTypeID;

        //  RQService.Pms.MigrateRoom(addParams).then((result) => {
        //    let response = result as any;

        //    if (response.HasErrorOrException) { loading.Dismiss(); return; }

        //    this.refreshList(() => { loading.Dismiss(); });
        //  });
      });
    }

    public SetDocTypeID(
      DocID: number
      , LangID: number
      , Description: string
      , TypeID: number
    ): void {
      console.log('Set DID :' + DocID);
      console.log("Desc" + Description);
      console.log("TypeID" + TypeID);

      let loading = this.NewLoading(
        this.app.Text('SavingMark', 'Saving...')
      );

      this.InAction = true;

      loading.Show(() => {
        //let addParams = RQParam.OtaD PmsMigrateRoomParams();
        let editDescriptionParams = RQParam.OtaEditHotelDocDescriptionParams();

        editDescriptionParams.HotelID = this.Hotel.HotelID;
        editDescriptionParams.DocID = DocID;
        editDescriptionParams.LangID = LangID;
        editDescriptionParams.DocTypeID = TypeID;// DocTypeID;
        editDescriptionParams.Description = Description;
        RQService.Ota.EditHotelDocDescription(editDescriptionParams).then((result) => {
          this.NewDocDescriptionEN = '';

          loading.Dismiss();

          this.refreshDocs(() => {
            this.SetInAction(false);
          });
        });
        //  addParams.HotelID = this.Hotel.HotelID;
        //  addParams.LangID = this.LangID;
        //  addParams.RoomID = RoomID;
        //  addParams.RoomTypeID = RoomTypeID;

        //  RQService.Pms.MigrateRoom(addParams).then((result) => {
        //    let response = result as any;

        //    if (response.HasErrorOrException) { loading.Dismiss(); return; }

        //    this.refreshList(() => { loading.Dismiss(); });
        //  });
      });
    }

    public SetFileSelected(event: any) {
        if (event.target.files && event.target.files[0]) { this.FileSelected = true; }
        else { this.FileSelected = false; }
    }

    public AddDoc() {
      console.log("AddDoc");
      if (this.GetInAction()) { return; }

      this.SetInAction(true);

      let loading = this.NewLoading(
          this.app.Text('SavingMark', 'Saving...')
      );
      console.log('filepicker');
      console.log(this.NewDocFileName);
      console.log("AddDoc-2");
      loading.Show(() => {
        RQService.Extensions.UploadHotelDoc(
          'filepicker'
          , (this.Hotel.ChainWantsHotelID > 0) ? this.Hotel.HotelID : 0
          , (result: any) => {
            console.log("in");
            console.log(result);
            let status = RQService.Extensions.PopulateUploadHotelDocRow(result[0]);
            console.log(status);
            loading.Dismiss();

            if (!status.FileUploadedOK) {
              let title: string = this.app.Text(
                'FileUploadError'
                , 'File Upload Error'
              );
              let message: string = this.app.Text(
                'ErrorUploadingFile'
                , 'Error Uploading File'
              );

              if (status.FileUploadErrorNo == 1) {
                message = this.app.Text(
                  'UnrecognisedFileExtension'
                  , 'Unrecognised file extension - must be one of: '
                  + '.png .jpeg .jpg .gif .tiff .bmp .pdf'
                );
              }

              if (
                status.FileUploadErrorNo == 2
                || status.FileUploadErrorNo == 13
              ) {
                message = this.app.Text(
                  'CantSaveFile'
                  , 'Server could not save file - '
                  + 'contact support@tobook.com for more info'
                );
              }

              if (status.FileUploadErrorNo == 11) {
                message = this.app.Text(
                  'NoFileSelected'
                  , 'No file selected for upload'
                );
              }

              if (status.FileUploadErrorNo == 12) {
                message = this.app.Text(
                  'SelectedFileTooLarge'
                  , 'The selected file is too large: max size is 20MB'
                );
              }

              this.ShowAlert(title, message);

              this.SetInAction(false);

              return;
            }

            let saving = this.NewLoading(
              this.app.Text('SavingMark', 'Saving...')
            );

            saving.Show(() => {
              console.log("in saving.Show");
              this.FileSelected = false;

              let editDescriptionParams = RQParam.OtaEditHotelDocDescriptionParams();

              editDescriptionParams.HotelID = this.Hotel.HotelID;
              editDescriptionParams.DocID = status.FileID;
              editDescriptionParams.LangID = this.LangID;
              editDescriptionParams.DocTypeID = 1;
              editDescriptionParams.Description = this.NewDocDescriptionEN;

              RQService.Ota.EditHotelDocDescription(
                editDescriptionParams
              ).then((result) => {
                this.NewDocDescriptionEN = '';

                saving.Dismiss();

                this.refreshDocs(() => {
                  this.SetInAction(false);
                });
              });
            });
          }
        );
      });
    }

    public DeleteDoc(pHotelDocID: number) {
        if (this.GetInAction()) { return; }

        this.ShowConfirmation(
            this.app.Text(
                'ConfirmDeleteAction'
                , 'Confirm Delete Action'
            )
            , this.app.Text(
                'ConfirmDeletePhoto'
                , 'Are you sure you want to delete this Brochure?'
            )
            , () => {
                if (this.GetInAction()) { return; }

                this.SetInAction(true);

                let loading = this.NewLoading(
                    this.app.Text('DeletingMark', 'Deleting...')
                );

                loading.Show(() => {
                    let deleteParams = RQParam.OtaDeleteHotelDocParams();

                    deleteParams.HotelID = this.Hotel.HotelID;
                    deleteParams.DocID  = pHotelDocID;

                    RQService.Ota.DeleteHotelDoc(deleteParams).then((result) => {
                        loading.Dismiss();

                        this.refreshDocs(() => {
                            this.SetInAction(false);
                        });
                    });
                });
            }
        );
    }

    public NudgeDoc(pHoteDocID: number, pUp: boolean) {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let nudgeParams = RQParam.OtaNudgeHotelDocSortOrderParams();

            nudgeParams.HotelID = this.Hotel.HotelID;
            nudgeParams.DocID = pHoteDocID;
            nudgeParams.Up = (pUp) ? 1 : 0;

            RQService.Ota.NudgeHotelDocSortOrder(nudgeParams).then((result) => {
                loading.Dismiss();

                this.refreshDocs(() => {
                    this.SetInAction(false);
                });
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/docs/xv-docs.ts